/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-a26b9c60.mjs';
import { _ as _slicedToArray } from '../../_chunks/dep-89b33ff6.mjs';
import { defineComponent, computed, createVNode, mergeProps } from 'vue';
import TDatePickerCell from './Cell.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { p as parseToDayjs } from '../../_chunks/dep-d8503ac7.mjs';
import { i as isArray_1 } from '../../_chunks/dep-0d1bd08c.mjs';
import { useConfig } from '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-6bcce672.mjs';
import '../../_chunks/dep-2d31a683.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-493c38ce.mjs';
import '../../_chunks/dep-b56b2dc0.mjs';
import '../../_chunks/dep-77f634fb.mjs';
import '../../_chunks/dep-28ae3cda.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-7211604f.mjs';
import '../../_chunks/dep-75df64b1.mjs';
import '../../_chunks/dep-48b9a098.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-52c1d6a9.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-6043e9fc.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-3a045465.mjs';
import '../../_chunks/dep-53dc0ac1.mjs';
import '../../_chunks/dep-b6b4eaa3.mjs';
import '../../_chunks/dep-881cffb7.mjs';
import '../../_chunks/dep-436b338d.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-3ddc95d0.mjs';
import '../../config-provider/type.mjs';
import '../../_chunks/dep-f373784b.mjs';
import '../../_chunks/dep-8bda6dda.mjs';
import '../../_chunks/dep-36563716.mjs';
import '../../_chunks/dep-91fc304f.mjs';
import '../../_common/js/log/index.mjs';
import '../../_common/js/log/log.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TDateTable = defineComponent({
  name: "TDatePickerTable",
  props: {
    mode: {
      type: String,
      "default": "date"
    },
    value: [String, Number, Array, Date],
    format: String,
    firstDayOfWeek: Number,
    data: Array,
    time: String,
    onCellClick: Function,
    onCellMouseEnter: Function,
    onCellMouseLeave: Function
  },
  setup: function setup(props) {
    var COMPONENT_NAME = usePrefixClass("date-picker__table");
    var _useConfig = useConfig("datePicker"),
      globalConfig = _useConfig.globalConfig;
    var dayjsLocale = globalConfig.value.dayjsLocale;
    var weekArr = computed(function () {
      var weekArr2 = [];
      var wi = props.firstDayOfWeek - 1;
      var len = globalConfig.value.weekdays.length;
      while (weekArr2.length < len) {
        weekArr2.push(globalConfig.value.weekdays[wi]);
        wi = (wi + len + 1) % len;
      }
      if (props.mode === "week") weekArr2.unshift(globalConfig.value.weekAbbreviation);
      return weekArr2;
    });
    var showThead = computed(function () {
      return props.mode === "date" || props.mode === "week";
    });
    var weekRowClass = function weekRowClass(value, format, targetValue) {
      if (props.mode !== "week" || !value) return {};
      if (isArray_1(value)) {
        var _startObj$locale, _startObj$locale$week, _endObj$locale, _endObj$locale$week;
        if (!value.length) return {};
        var _value$map = value.map(function (v) {
            return v && parseToDayjs(v, format);
          }),
          _value$map2 = _slicedToArray(_value$map, 2),
          startObj = _value$map2[0],
          endObj = _value$map2[1];
        var startYear = startObj && startObj.year();
        var startWeek = startObj === null || startObj === void 0 || (_startObj$locale = startObj.locale) === null || _startObj$locale === void 0 || (_startObj$locale = _startObj$locale.call(startObj, dayjsLocale)) === null || _startObj$locale === void 0 || (_startObj$locale$week = _startObj$locale.week) === null || _startObj$locale$week === void 0 ? void 0 : _startObj$locale$week.call(_startObj$locale);
        var endYear = endObj && endObj.year();
        var endWeek = endObj === null || endObj === void 0 || (_endObj$locale = endObj.locale) === null || _endObj$locale === void 0 || (_endObj$locale = _endObj$locale.call(endObj, dayjsLocale)) === null || _endObj$locale === void 0 || (_endObj$locale$week = _endObj$locale.week) === null || _endObj$locale$week === void 0 ? void 0 : _endObj$locale$week.call(_endObj$locale);
        var targetObj = parseToDayjs(targetValue, format);
        var targetYear = targetObj.year();
        var targetWeek = targetObj.week();
        var isActive = targetYear === startYear && targetWeek === startWeek || targetYear === endYear && targetWeek === endWeek;
        var isRange = targetYear >= startYear && targetYear <= endYear && targetWeek > startWeek && targetWeek < endWeek;
        return _defineProperty(_defineProperty({}, "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--active"), isActive), "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--range"), isRange);
      }
      return _defineProperty({}, "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--active"), parseToDayjs(value, format).locale(dayjsLocale).week() === parseToDayjs(targetValue, format).locale(dayjsLocale).week());
    };
    return function () {
      return createVNode("div", {
        "class": COMPONENT_NAME.value,
        "onMouseleave": function onMouseleave(e) {
          var _props$onCellMouseLea;
          return (_props$onCellMouseLea = props.onCellMouseLeave) === null || _props$onCellMouseLea === void 0 ? void 0 : _props$onCellMouseLea.call(props, {
            e: e
          });
        }
      }, [createVNode("table", null, [showThead.value && createVNode("thead", null, [createVNode("tr", null, [weekArr.value.map(function (value, i) {
        return createVNode("th", {
          "key": i
        }, [value]);
      })])]), createVNode("tbody", null, [props.data.map(function (row, i) {
        return createVNode("tr", {
          "key": i,
          "class": _objectSpread(_defineProperty({}, "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row"), true), weekRowClass(props.value, props.format, row[0].value))
        }, [row.map(function (col, j) {
          return createVNode(TDatePickerCell, mergeProps(col, {
            "key": j,
            "time": props.time,
            "onClick": props.onCellClick,
            "onMouseEnter": props.onCellMouseEnter
          }), null);
        })]);
      })])])]);
    };
  }
});

export { TDateTable as default };
//# sourceMappingURL=Table.mjs.map
